import axios from "axios";
import { API_BASE_URL, LAMBDA_BASE_URL } from "../../../../constants";
import { getDomainId } from "../../../../utils/utils";

const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

const getAllDatesInRange = (startDate, endDate) => {
  const dates = [];
  const current = new Date(startDate);
  const end = new Date(endDate);

  while (current <= end) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }

  return dates;
};

const GradientLineChartData2 = async (start, end) => {
  try {
    const domainId = await getDomainId();

    const res1 = await axios.get(
      `${LAMBDA_BASE_URL}/date-range-search-count?start_date=${start}&end_date=${end}`,
      {
        headers: {
          "DOMAIN-TOKEN": domainId,
        },
      }
    );

    const res2 = await axios.get(
      `${LAMBDA_BASE_URL}/date-range-unanswered-count?start_date=${start}&end_date=${end}`,
      {
        headers: {
          "DOMAIN-TOKEN": domainId,
        },
      }
    );

    const result1 = Array.isArray(res1.data.result) ? res1.data.result : [];
    const result2 = Array.isArray(res2.data.result) ? res2.data.result : [];

    const countMap1 = {};
    result1.forEach((item) => {
      const dateStr = formatDate(item.created_date);
      countMap1[dateStr] = item.count;
    });

    const countMap2 = {};
    result2.forEach((item) => {
      const dateStr = formatDate(item.created_date);
      countMap2[dateStr] = item.unanswered_count;
    });

    const fullDateList = getAllDatesInRange(start, end);
    const labels = fullDateList.map((date) => formatDate(date));
    const values1 = fullDateList.map((date) => countMap1[formatDate(date)] || 0);
    const values2 = fullDateList.map((date) => countMap2[formatDate(date)] || 0);
    // console.log(values2)

    return {
      labels,
      datasets: [
        {
          label: "Answered",
          color: "teal",
          data: values1,
        },
        {
          label: "Unanswered",
          color: "primary",
          data: values2,
        },
      ],
    };
  } catch (error) {
    console.error("Failed to fetch chart data:", error);
    return {
      labels: [],
      datasets: [],
    };
  }
};

export default GradientLineChartData2;
